import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { nanoid } from '@reduxjs/toolkit';
import CloseIcon from '@mui/icons-material/Close';

function FilterChips({ selectedFilter, setSelectedFilter, changeHandler }) {
  const handleDelete = (item, field) => {
    const newData = selectedFilter?.[field]?.filter((i) => i !== item);
    setSelectedFilter({
      ...selectedFilter,
      [field]: newData
    });
    changeHandler({ target: { value: selectedFilter[field].filter((filter) => filter !== item) } }, field);
  };

  const GenerateChips = (filterName) => {
    return selectedFilter?.[filterName]?.map((item) => (
      <Chip
        sx={{
          border: '1px solid #0194d3'
        }}
        deleteIcon={
          <CloseIcon
            style={{
              color: '#0194d3'
            }}
          />
        }
        key={nanoid()}
        label={item}
        variant="outlined"
        onDelete={() => handleDelete(item, filterName)}
      />
    ));
  };

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {GenerateChips('function')}
      {GenerateChips('industry')}
      {GenerateChips('contract_type')}
      {GenerateChips('date_posted')}
    </Stack>
  );
}
export default FilterChips;
